// extracted by mini-css-extract-plugin
export var gif = "_cd-0";